import { Link } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { eur } from "@/lib/api";

export default function CartDrawer() {
  const { items, open, setOpen, setQty, remove, total } = useCart();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" side="right" className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="p-6 border-b">
          <SheetTitle className="font-display text-xl uppercase tracking-tight">Carrello ({items.length})</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-6 flex flex-col gap-5">
          {items.length === 0 && (
            <p data-testid="cart-empty-message" className="text-muted-foreground text-sm">
              Il carrello è vuoto. Trova la catena giusta per la tua motosega.
            </p>
          )}
          {items.map((i) => (
            <div key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-4">
              <img src={i.image} alt={i.name} className="w-20 h-20 object-cover border border-[#e5e5e5]" />
              <div className="flex-1">
                <div className="text-sm font-semibold leading-snug">{i.name}</div>
                <div className="text-sm text-[#ff4500] font-semibold mt-1">{eur(i.price)}</div>
                <div className="mt-2 flex items-center gap-2">
                  <button data-testid={`qty-minus-${i.id}`} onClick={() => setQty(i.id, i.quantity - 1)} className="border border-[#e5e5e5] p-1 hover:border-[#0a0a0a] transition-colors" aria-label="Diminuisci">
                    <Minus className="w-3.5 h-3.5" />
                  </button>
                  <span className="text-sm font-mono w-6 text-center">{i.quantity}</span>
                  <button data-testid={`qty-plus-${i.id}`} onClick={() => setQty(i.id, i.quantity + 1)} className="border border-[#e5e5e5] p-1 hover:border-[#0a0a0a] transition-colors" aria-label="Aumenta">
                    <Plus className="w-3.5 h-3.5" />
                  </button>
                  <button data-testid={`remove-item-${i.id}`} onClick={() => remove(i.id)} className="ml-auto text-muted-foreground hover:text-[#ff4500] transition-colors" aria-label="Rimuovi">
                    <Trash2 className="w-4 h-4" strokeWidth={1.5} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t p-6">
            <div className="flex justify-between font-display font-semibold text-lg">
              <span>Totale</span>
              <span data-testid="cart-total" className="text-[#ff4500]">{eur(total)}</span>
            </div>
            <p className="text-xs text-muted-foreground mt-1">Spedizione calcolata al checkout · IVA inclusa</p>
            <div className="mt-4 flex flex-col gap-2">
              <Link data-testid="drawer-checkout-button" to="/checkout" onClick={() => setOpen(false)} className="btn-hard w-full">
                Vai al checkout
              </Link>
              <Link data-testid="drawer-cart-link" to="/carrello" onClick={() => setOpen(false)} className="btn-outline-hard w-full !py-3 text-xs">
                Vedi carrello completo
              </Link>
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
